/* Featured products — quantity selector + AJAX add to cart (opens drawer)
   + variant picker for products with options */

(function () {
  'use strict';
  if (window.__featuredProductsReady) return;
  window.__featuredProductsReady = true;

  document.addEventListener('DOMContentLoaded', function () {
    /* Featured products swiper */
    document.querySelectorAll('.featured-products_swiper').forEach(function (el) {
      var slidesCount = el.querySelectorAll('.swiper-slide').length;
      if (slidesCount <= 1) return;

      var inner = el.closest('.featured-products_inner') || el.parentElement;
      var fill = inner && inner.querySelector('.featured-products_progress-fill');
      var prev = inner && inner.querySelector('.featured-products_prev');
      var next = inner && inner.querySelector('.featured-products_next');

      function updateProgress(swiper) {
        if (!fill || !swiper || !swiper.slides || swiper.slides.length === 0) return;
        var progress = (swiper.activeIndex + 1) / swiper.slides.length;
        fill.style.width = (progress * 100) + '%';
      }

      var isDetailed = el.classList.contains('featured-products_swiper--detailed');
      var wrapDesktop = el.classList.contains('featured-products_swiper--wrap-desktop');
      var desktopSlidesPerView = isDetailed ? 1 : 3;
      var swiperConfig = {
        slidesPerView: desktopSlidesPerView,
        spaceBetween: 26,
        breakpoints: {
          0: {
            slidesPerView: 1.19,
            spaceBetween: 16
          },
          992: {
            slidesPerView: desktopSlidesPerView,
            spaceBetween: 26
          }
        },
        on: {
          init: function () { updateProgress(this); },
          slideChange: function () { updateProgress(this); }
        }
      };

      if (wrapDesktop) {
        swiperConfig.slidesPerView = 1.19;
        swiperConfig.spaceBetween = 16;
        swiperConfig.breakpoints = {
          0: {
            enabled: true,
            slidesPerView: 1.19,
            spaceBetween: 16
          },
          992: {
            enabled: false
          }
        };
      }

      var swiper = new Swiper(el, swiperConfig);

      if (prev) prev.addEventListener('click', function () { swiper.slidePrev(); });
      if (next) next.addEventListener('click', function () { swiper.slideNext(); });
    });

    /* Variant picker — update price, variant id, show add-to-cart */
    document.querySelectorAll('[data-product-card][data-has-variants="true"]').forEach(function (card) {
      var form = card.querySelector('[data-product-card-form]');
      var jsonEl = card.querySelector('[data-variants-json]');
      var variantIdInput = card.querySelector('[data-variant-id]');
      var priceEl = card.querySelector('[data-price]');
      var compareEl = card.querySelector('[data-compare-price]');
      var chooseBtn = card.querySelector('[data-product-card-choose-btn]');
      var addRow = card.querySelector('[data-product-card-add-row]');
      var addBtn = card.querySelector('[data-product-card-add-btn]');
      var soldOutBtn = card.querySelector('[data-product-card-sold-out-btn]');
      var qtyWrap = card.querySelector('[data-product-card-qty-wrap]');
      var opts = card.querySelectorAll('[data-variant-option]');

      if (!form || !jsonEl || !variantIdInput || !priceEl || !chooseBtn || !addRow || !addBtn) return;

      var variants;
      try {
        variants = JSON.parse(jsonEl.textContent);
      } catch (e) {
        return;
      }

      function findVariantByOption(optionValue) {
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].option1 === optionValue) return variants[i];
        }
        return null;
      }

      function updateCtaState(variant) {
        if (!variant) return;
        var isAvailable = !!variant.available;
        if (qtyWrap) qtyWrap.hidden = !isAvailable;
        if (addBtn) {
          addBtn.hidden = !isAvailable;
          addBtn.disabled = !isAvailable;
        }
        if (soldOutBtn) soldOutBtn.hidden = isAvailable;
      }

      function selectVariant(variant) {
        variantIdInput.value = variant.id;
        var fmt = (window.theme && window.theme.formatMoney) || function(c) { return '$' + (c / 100).toFixed(2); };
        priceEl.textContent = fmt(variant.price);
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          if (!compareEl) {
            compareEl = document.createElement('span');
            compareEl.className = 'text-body text-claret line-through opacity-50 product-card_compare-price';
            compareEl.setAttribute('data-compare-price', '');
            priceEl.parentNode.insertBefore(compareEl, priceEl.nextSibling);
          }
          compareEl.textContent = fmt(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          if (compareEl) compareEl.style.display = 'none';
        }
        updateCtaState(variant);
        chooseBtn.classList.add('product-card_choose-btn--hidden');
        chooseBtn.disabled = true;
        addRow.classList.remove('product-card_add-row--hidden');
      }

      var selectedOpt = card.querySelector('[data-variant-option].is-selected');
      if (selectedOpt) {
        var selectedVariant = findVariantByOption(selectedOpt.getAttribute('data-option-value'));
        if (selectedVariant) {
          selectVariant(selectedVariant);
        }
      }

      opts.forEach(function (btn) {
        if (btn.disabled) return;
        btn.addEventListener('click', function () {
          var val = btn.getAttribute('data-option-value');
          var v = findVariantByOption(val);
          if (!v) return;
          opts.forEach(function (b) { b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          selectVariant(v);
        });
      });
    });
    /* Quantity +/- buttons — simple +1/-1 */
    document.querySelectorAll('.featured-products_card .js-product-form, .product-card .js-product-form, .product-card-detailed .js-product-form, .main-product_form.js-product-form').forEach(function (form) {
      const input = form.querySelector('[data-qty-input]');
      const decBtn = form.querySelector('.js-qty-decrease');
      const incBtn = form.querySelector('.js-qty-increase');

      if (!input || !decBtn || !incBtn) return;

      decBtn.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, v - 1);
      });

      incBtn.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        input.value = Math.min(99, v + 1);
      });

      input.addEventListener('change', function () {
        var v = parseInt(input.value, 10);
        if (isNaN(v) || v < 1) input.value = 1;
        else if (v > 99) input.value = 99;
      });
    });

    /* Add to cart — delegated AJAX submit so dynamic drawer forms are always intercepted */
    document.addEventListener('submit', function (e) {
      var form = e.target && e.target.closest ? e.target.closest('form.js-product-form') : null;
      if (!form) return;
      if (!form.matches('.featured-products_card .js-product-form, .product-card .js-product-form, .product-card-detailed .js-product-form, .cart-drawer_upsell-add.js-product-form, .main-product_form.js-product-form')) return;

      e.preventDefault();

      const submitBtn = form.querySelector('[type="submit"]');
      const supportsLoadingDots = submitBtn ? submitBtn.hasAttribute('data-loading-dots') : false;
      if (submitBtn) {
        submitBtn.disabled = true;
        if (supportsLoadingDots) {
          submitBtn.classList.add('is-loading');
        } else {
          submitBtn.textContent = '...';
        }
      }

      var formData = new FormData(form);
      formData.append('sections', 'cart-drawer');
      var body = new URLSearchParams(formData);

      var cartAddUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/add.js';
      fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body
      })
        .then(function (r) {
          return r.text().then(function (text) {
            var data = null;
            if (text) {
              try {
                data = JSON.parse(text);
              } catch (err) {
                data = { raw: text };
              }
            }
            return { ok: r.ok, status: r.status, data: data, raw: text };
          });
        })
        .then(function (result) {
          if (result.ok) {
            const drawer = document.querySelector('.js-cart-drawer');
            if (drawer && result.data.sections && result.data.sections['cart-drawer']) {
              var prevFill = drawer.querySelector('.cart-drawer_shipping-fill');
              var prevWidth = prevFill && prevFill.dataset.width ? parseInt(prevFill.dataset.width, 10) : null;
              var parser = new DOMParser();
              var doc = parser.parseFromString(result.data.sections['cart-drawer'], 'text/html');
              var newDrawer = doc.querySelector('.js-cart-drawer');
              if (newDrawer) {
                drawer.innerHTML = newDrawer.innerHTML;
                if (window.animateCartDrawerShippingBars) window.animateCartDrawerShippingBars(prevWidth);
              }
            } else if (drawer && drawer.dataset.sectionId && window.refreshCartDrawer) {
              window.refreshCartDrawer(drawer.dataset.sectionId).then(function () {});
            }
            if (window.openCartDrawer) window.openCartDrawer();
          } else if (result.data && result.data.description) {
            alert(result.data.description);
          } else {
            alert('Could not add to cart (' + result.status + ').');
            if (window.console && window.console.warn) {
              window.console.warn('Add to cart error response:', result.raw);
            }
          }
        })
        .catch(function (err) {
          alert('Could not add to cart. Please try again.');
          if (window.console && window.console.error) {
            window.console.error('Add to cart request failed:', err);
          }
        })
        .finally(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            if (supportsLoadingDots) {
              submitBtn.classList.remove('is-loading');
            } else {
              submitBtn.textContent = form.classList.contains('cart-drawer_upsell-add') ? '+' : 'ADD TO CART';
            }
          }
        });
    });
  });
})();



